import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { TextLink } from '@sbt-web/ui';
import { reviewerNameClickAction } from '@/tools/tracking/ProfileTracking';
import type { ReviewFlow, ReviewRole } from '@/types';
import styles from './index.module.scss';
interface ReviewInfoProps {
  userName: string;
  reviewerName: string;
  date: string;
  reviewerRole: ReviewRole;
  flow: ReviewFlow;
  userId: string;
  itemTitle?: string;
  isAutomaticReview?: boolean;
  reviewerProfileUrl?: string;
}
interface AutomaticReviewTextProps {
  userName: string;
  date: string;
  reviewerRole: ReviewRole;
  isDeletedUser: boolean;
  itemTitle?: string;
}
type ReviewTextProps = Omit<ReviewInfoProps, 'isAutomaticReview'> & {
  isDeletedUser: boolean;
};
const DELETED_PROFILE_NAME = 'Profilo cancellato';
const AutomaticReviewText = t0 => {
  const $ = _c(8);
  const {
    reviewerRole,
    itemTitle,
    date,
    userName,
    isDeletedUser
  } = t0;
  const isBuyer = reviewerRole === "BUYER";
  const infoToken = itemTitle ? `${itemTitle}, ${date}` : `${date}`;
  let t1;
  if ($[0] !== isDeletedUser) {
    t1 = classNames({
      [styles.deleted_account]: isDeletedUser
    }, "body-text semibold small");
    $[0] = isDeletedUser;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = isDeletedUser ? DELETED_PROFILE_NAME : userName;
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <span className={t1}>{t2}</span>;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = `ha ${isBuyer ? "venduto" : "acquistato"} con TuttoSubito: ${infoToken}`;
  let t5;
  if ($[5] !== t3 || $[6] !== t4) {
    t5 = <>{t3} {t4}</>;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
const ReviewText = t0 => {
  const $ = _c(8);
  const {
    reviewerRole,
    flow,
    userName,
    itemTitle,
    date,
    userId,
    reviewerName,
    reviewerProfileUrl,
    isDeletedUser
  } = t0;
  const isBuyer = reviewerRole === "BUYER";
  const textToken = `${isBuyer ? "acquistato" : "venduto"}${flow === "PAB" ? "" : " con TuttoSubito"}${isBuyer ? " da" : " a"}`;
  const infoToken = itemTitle ? `${itemTitle}, ${date}` : `${date}`;
  let t1;
  if ($[0] !== isDeletedUser || $[1] !== reviewerName || $[2] !== reviewerProfileUrl || $[3] !== userId) {
    t1 = isDeletedUser ? <span className={classNames("body-text semibold small", {
      [styles.deleted_account]: isDeletedUser
    })}>{DELETED_PROFILE_NAME}</span> : <TextLink size="sm" href={reviewerProfileUrl} onClick={() => reviewerNameClickAction(userId)} themed={false} weight="semibold">{reviewerName}</TextLink>;
    $[0] = isDeletedUser;
    $[1] = reviewerName;
    $[2] = reviewerProfileUrl;
    $[3] = userId;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const t2 = `ha ${textToken} ${userName}: ${infoToken}`;
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <>{t1} {t2}</>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export const ReviewInfo = t0 => {
  const $ = _c(11);
  const {
    userName,
    reviewerRole,
    reviewerName,
    flow,
    itemTitle,
    date,
    userId,
    isAutomaticReview,
    reviewerProfileUrl
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classNames("body-text small", styles.info_box);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== date || $[2] !== flow || $[3] !== isAutomaticReview || $[4] !== itemTitle || $[5] !== reviewerName || $[6] !== reviewerProfileUrl || $[7] !== reviewerRole || $[8] !== userId || $[9] !== userName) {
    t2 = <p className={t1}>{isAutomaticReview ? <AutomaticReviewText reviewerRole={reviewerRole} itemTitle={itemTitle} date={date} userName={userName} isDeletedUser={userName.length === 0} /> : <ReviewText reviewerRole={reviewerRole} itemTitle={itemTitle} date={date} userName={userName} userId={userId} flow={flow} reviewerName={reviewerName} reviewerProfileUrl={reviewerProfileUrl} isDeletedUser={reviewerName.length === 0} />}</p>;
    $[1] = date;
    $[2] = flow;
    $[3] = isAutomaticReview;
    $[4] = itemTitle;
    $[5] = reviewerName;
    $[6] = reviewerProfileUrl;
    $[7] = reviewerRole;
    $[8] = userId;
    $[9] = userName;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
};